module.exports = __webpack_public_path__ + "img/icon-cart-black.b48f704b.svg";